<template>
  <el-dialog :visible.sync="visible" title="移除维度" append-to-body :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataForm" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
             :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="选中移除维度" prop="type">
        <el-checkbox-group v-model="dataForm.type" >
          <el-checkbox v-for="type in types" @change="getType(type.id)" :key="type.id" :label="type.id" name="type">{{type.examineTypeName}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>

import { Loading } from 'element-ui'
import qs from 'qs'
import Cookies from 'js-cookie'

export default {
  name: 'teaching-quality-export',
  methods: {
    init () {
      this.visible = true
      this.getList()
    },
    getList () {
      this.$http
        .post(
          '/classEvaluate/examineType/getExamineTypeList/'
        )
        .then(({ data }) => {
          if (data.code !== 0) {
            return this.$message.error(data.msg)
          }
          this.types = data.data
          this.dataForm.type = this.types.filter((i)=>{
            return i.isRemoveDimension == 1
          }).map((i)=>{
            return i.id
          })
          console.log('选中',this.dataForm.type)
          console.log(this.types,'0')
        })
    },
    getType (id) {
      console.log(this.dataForm.type)
      if (this.dataForm.type.length === this.types.length) {
        this.dataForm.type.pop()
        return this.$message.error('请至少保留一项')
      }
      this.removeType()
      this.$emit('checkedTypes', this.dataForm.type)
    },
    removeType(){
      
      this.$http.post('/classEvaluate/examineType/reviseExamineTypeIsRemoveDimension',this.dataForm.type).then(({ data }) => {
          if (data.code !== 0) {
            return this.$message.error(data.msg)
          }
          
          
          
          console.log(this.types)
        })
    }
  },
  data () {
    return {
      visible: false,
      htmlPanelVisible: false,
      types: [],
      showTypeList: [],
      dataForm: {
        examMassAnalysisDTOS: [],
        type: []
      }
    }
  },
  components: { }
}
</script>

<style scoped>

</style>
